import styled from "styled-components";

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
  margin-top: 2rem;
`;

export const InputField = styled.input`
  border: 2px solid ${({ theme }) => theme.borderColors.purple};
  padding: 0.7rem;
  padding-left: 0.5rem;
  border-radius: 0.5rem;
  outline: none;
  margin-top: 0.2rem;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.primary};

 

  @media (max-width: 768px) {
    padding: 1rem 0.6rem;
  }
`;

export const TextArea = styled.textarea`
  border: 2px solid ${({ theme }) => theme.borderColors.purple};
  padding: 0.5rem;
  border-radius: 0.5rem;
  outline: none;
  margin-top: 0.2rem;
  background-color: transparent;
  width: 100%;
  resize: none;
  color: ${({ theme }) => theme.colors.primary};
`;
